import { useQuery } from "@tanstack/react-query";
import { supabase } from "../lib/supabase";

interface OperatorStats {
  total: number;
  hotel: number;
  dmo: number;
}

async function fetchOperatorStats(): Promise<OperatorStats> {
  // Total count
  const { count: total } = await supabase
    .from("operators")
    .select("*", { count: "exact", head: true });

  // Hotel count (macro_category includes hotel-related)
  const { count: hotel } = await supabase
    .from("operators")
    .select("*", { count: "exact", head: true })
    .or("macro_category.ilike.%hotel%,macro_category.ilike.%accomodation%");

  // DMO count
  const { count: dmo } = await supabase
    .from("operators")
    .select("*", { count: "exact", head: true })
    .or("macro_category.ilike.%dmo%,macro_category.ilike.%destinazion%");

  return {
    total: total ?? 0,
    hotel: hotel ?? 0,
    dmo: dmo ?? 0,
  };
}

function formatCount(n: number): string {
  if (n >= 1000) return `${Math.floor(n / 1000)}k+`;
  return `${n}+`;
}

export function useOperatorStats() {
  return useQuery({
    queryKey: ["operator-stats"],
    queryFn: fetchOperatorStats,
    staleTime: 1000 * 60 * 30, // 30 min
    gcTime: 1000 * 60 * 60, // 1 hour
  });
}

export { formatCount };
